import getJwt from '@/api/jwt'
import api from './axiosApi'

export default api

export const auth = getJwt(api.base())
export const authConfig = getJwt(api.base()).jwtConfig
